module.exports = __webpack_public_path__ + "img/app.3c8a36ae.svg";